'use strict';
(function () {
  angular.module('pentaApp').factory('scoringRules.modal', factory);
  factory.$inject = ['bottomModal.factory'];
  function factory(bottomModal) {
    return bottomModal.create({
      controller: controller,
      templateUrl: 'newClub/modals/scoringRules/scoringRules.modal.jade',
    });
  }

  controller.$inject = ['$scope', 'modal', 'data', '$injector'];
  function controller($scope, modal, data, $injector) {
    $scope.close = function () {
      modal.close();
    };

    init();
    ///////////////////////
    function init() {
      $scope.title = i18next.t('Reglas para sumar puntos');
      if (!data || !data.rules || !data.rules.length) $scope.list = [];
      $scope.list = data.rules;
    }

  }
})();
